import { FreewheelParameterType } from 'tag/ts/tag/ads/freewheel/enums/FreewheelParameterType';
import { AbstractFreewheelParameter } from 'tag/ts/tag/ads/freewheel/parameters/AbstractFreewheelParameter';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Represents a parameter within a Freewheel request
 */
export class FreewheelParameter extends AbstractFreewheelParameter {
	constructor( key: string, value: string, type: FreewheelParameterType, name?: string ) {
		super( {
			key: key,
			value: value,
			type: type,
			name: name
		} );
	}
}